import React, {ChangeEvent, FormEvent, useState} from 'react';
import { IModalDialogHandler } from '../../services/dialog/dialog.service.interface';
import {observer} from "mobx-react";
import { QAEnvironmentPopUpBlockerContainerBox } from './boxes/content-container/qa-environment-pop-up-blocker-container.box'
import { QAEnvironmentPopUpBlockerFormContainerBox } from './boxes/form-container/qa-environment-pop-up-blocker-form-container.box'
import { QAEnvironmentPopUpBlockerInputBox } from './boxes/password-input/qa-environment-pop-up-blocker-password-input.box'
import { QAEnvironmentPopUpBlockerInformationTextBox } from './boxes/information-text/qa-environment-pop-up-blocker-information-text.box'
import { QAEnvironmentPopUpBlockerErrorTextBox } from './boxes/error-text/qa-environment-pop-up-blocker-error-text.box'
import { Button } from '../../basic-ui-components/button/base/button.component';
import {useServices} from "../../react-hooks/use-services.hook";
import {ShowPasswordButtonBox} from "./boxes/show-password-button/show-password-button.box";


interface QAEnvironmentPopUpBlockerProps {
    dialogHandler: IModalDialogHandler;
}

export const QAEnvironmentPopUpBlocker: React.FC<QAEnvironmentPopUpBlockerProps> = observer((props) => {
    const services = useServices();
    const [password, setPassword] = useState('');
    const [isPasswordValid, setIsPasswordValid] = useState(true);
    const [showPassword, setShowPassword] = useState(false);

    const handlePasswordChange = (event: ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    }

    const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        const validPassword = services.qaEnvironmentPopUpBlockerService.validatePassword(password);
        setIsPasswordValid(validPassword);


        if (validPassword) {
            props.dialogHandler.close();
        }

    }

    const onShowPasswordClick = () => {
        setShowPassword(!showPassword);
    }

    const renderPasswordError = () => {
        if (!isPasswordValid) {
            return (
                <QAEnvironmentPopUpBlockerErrorTextBox>
                    Wrong password, please try again!
                </QAEnvironmentPopUpBlockerErrorTextBox>
            );
        }

        return null;
    }



    return (
        <QAEnvironmentPopUpBlockerContainerBox>
            <QAEnvironmentPopUpBlockerFormContainerBox onSubmit={handleSubmit}>
                <QAEnvironmentPopUpBlockerInformationTextBox>
                    This environment is for testing purpose. To access it insert the environment password.
                </QAEnvironmentPopUpBlockerInformationTextBox>
                <QAEnvironmentPopUpBlockerInputBox type={showPassword ? 'text' : 'password'}
                                                   autoComplete={'off'}
                                                   placeholder={'Environment password'}
                                                   value={password}
                                                   onChange={handlePasswordChange}
                />
                <ShowPasswordButtonBox onClick={onShowPasswordClick}>
                    {showPassword ? 'Hide password' : 'Show password'}
                </ShowPasswordButtonBox>

                <Button preset="special" type="submit" fullWidth>Submit</Button>
                {renderPasswordError()}
            </QAEnvironmentPopUpBlockerFormContainerBox>
        </QAEnvironmentPopUpBlockerContainerBox>
    );
})